module.exports = __webpack_public_path__ + "img/layout_top_tree_left_right.bde38b6e.svg";